<template>
    <div class="ppv2-bg-[#9620D5] ppv2-bg-opacity-5 ppv2-rounded-[20px]" :style="{ padding: normalizeSize(30, true) }">
        <div class="ppv2-flex ppv2-flex-col lg:ppv2-flex-row ppv2-gap-12 lg:ppv2-gap-24 align-items-center">
            <!-- Left Header -->
            <div class="ppv2-w-full lg:ppv2-w-[35%]">
                <h2
                    class="poppinsBold ppv2-leading-tight"
                    :style="{ fontSize: normalizeFontSize(35), marginBottom: normalizeSize(18, true) }"
                >
                    <span class="ppv2-text-black">{{ $t('subscription.faq.title_top') }}</span
                    ><br />
                    <span class="ppv2-text-[#AC7CFF]">{{ $t('subscription.faq.title_bottom') }}</span>
                </h2>
                <p class="poppinsRegular ppv2-text-black ppv2-opacity-60" :style="{ fontSize: normalizeFontSize(13) }">
                    {{ $t('subscription.faq.subtitle') }}
                </p>
            </div>

            <!-- Right FAQ Items -->
            <div class="ppv2-w-full lg:ppv2-w-[65%] ppv2-space-y-4">
                <div
                    v-for="(faq, index) in faqs"
                    :key="index"
                    :class="[
                        'ppv2-rounded-[18px] ppv2-transition-all ppv2-duration-300 ppv2-overflow-hidden',
                        openFaqIndex === index ? 'ppv2-bg-white ppv2-shadow-xl' : 'ppv2-bg-[#F4F4F9]',
                    ]"
                >
                    <button
                        @click="toggleFaq(index)"
                        :class="[
                            'ppv2-bg-opacity-5',
                            openFaqIndex === index ? 'ppv2-bg-white dark:ppv2-bg-dark' : 'ppv2-bg-black dark:ppv2-bg-dark',
                        ]"
                        class="ppv2-w-full ppv2-flex ppv2-items-center ppv2-justify-between ppv2-text-left"
                        :style="{ padding: normalizeSize(20, true) }"
                    >
                        <h3 class="poppinsMedium mb-0 ppv2-pr-8" :style="{ fontSize: normalizeFontSize(16) }">
                            {{ $t(faq.question) }}
                        </h3>
                        <svg
                            :class="[
                                'ppv2-w-4 ppv2-h-4 ppv2-flex-shrink-0 ppv2-transition-transform ppv2-duration-300 ppv2-text-black',
                                openFaqIndex === index ? 'ppv2-rotate-180' : 'ppv2--rotate-90',
                            ]"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M19 9L12 16L5 9"
                                stroke="currentColor"
                                stroke-width="2.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </button>

                    <transition name="faq" @enter="enter" @leave="leave">
                        <div
                            v-show="openFaqIndex === index"
                            :style="{ padding: normalizeSize(20, true) }"
                            class="dark:ppv2-bg-dark"
                        >
                            <p
                                class="poppinsMedium ppv2-text-black ppv2-opacity-70 ppv2-leading-relaxed ppv2-max-w-[90%]"
                                :style="{ fontSize: normalizeFontSize(15) }"
                            >
                                {{ $t(faq.answer) }}
                            </p>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import normalizeSize from '../../utils/normalizeSize'
import { faqs } from './constants'
import normalizeFontSize from '../../utils/normalizeFontSize'

export default {
    name: 'SubscriptionFaq',
    data() {
        return {
            faqs,
            openFaqIndex: 0,
        }
    },
    methods: {
        normalizeFontSize,
        normalizeSize,
        toggleFaq(index) {
            this.openFaqIndex = this.openFaqIndex === index ? null : index
        },
        enter(el) {
            el.style.maxHeight = el.scrollHeight + 20 + 'px'
        },
        leave(el) {
            el.style.maxHeight = '0'
        },
    },
}
</script>

<style scoped>
/* Vue 2 transition styles */
.faq-enter-active,
.faq-leave-active {
    transition: all 0.3s ease;
}

.faq-enter,
.faq-leave-to {
    opacity: 0;
    max-height: 0 !important;
}

.faq-enter-to,
.faq-leave {
    opacity: 1;
}
</style>
